import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem } from "namirasoft-core";
import { FuelRow, NamirasoftERPMetaDatabase, RefuelingInputRow, RefuelingRow, RefuelingUnit, VehicleRow } from "namirasoft-erp";
import { NSBox, NSBoxBoolean, NSBoxDateTime, NSBoxEntity, NSBoxEnum, NSBoxInteger, NSBoxTextArea, NSColumn, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class RefuelingEditPage extends Component<Props>
{
    Vehicle = createRef<NSBoxEntity<VehicleRow>>();
    Fuel = createRef<NSBoxEntity<FuelRow>>();
    Datetime = createRef<NSBoxDateTime>();
    Quantity = createRef<NSBoxInteger>();
    Unit = createRef<NSBoxEnum<RefuelingUnit>>();
    IsFullTank = createRef<NSBoxBoolean>();
    Description = createRef<NSBoxTextArea>();

    override render()
    {
        let db = new NamirasoftERPMetaDatabase(this.props.account.token_manager, console.error);

        return (
            <ErpLayout<RefuelingRow, RefuelingInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.refueling(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): RefuelingInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        branch_id: ErpScope.getBranchId() ?? "",
                                        vehicle_id: this.Vehicle.current?.getValueOne() ?? "",
                                        fuel_id: this.Fuel.current?.getValueOne() ?? "",
                                        datetime: new Date(this.Datetime.current?.getValue() ?? new Date().toISOString()),
                                        quantity: this.Quantity.current?.getValue() ?? 0,
                                        unit: this.Unit.current?.getValueEnumOne(RefuelingUnit, RefuelingUnit.Liter) ?? RefuelingUnit.Liter,
                                        is_full_tank: this.IsFullTank.current?.getValueBool() ?? false,
                                        description: this.Description.current?.getValue() ?? null,
                                        refueling_category: [],
                                        refueling_tag: [],
                                        refueling_field: [],
                                    }),
                                    setRow: (row: RefuelingRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id, branch_id: row.branch_id });
                                        this.Vehicle.current?.setValueOne(row.vehicle_id);
                                        this.Fuel.current?.setValueOne(row.fuel_id);
                                        this.Datetime.current?.setValue(new Date(row.datetime).toISOString());
                                        this.Quantity.current?.setValue(row.quantity);
                                        this.Unit.current?.setValueOne(row.unit);
                                        this.IsFullTank.current?.setValueBool(row.is_full_tank);
                                        this.Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxEntity<VehicleRow>
                        ref={this.Vehicle} title="Vehicle" required multiple={false}
                        table_name="vehicle" table={db.tables.vehicle}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.vehicle, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.vehicle, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.vehicle.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxEntity<FuelRow>
                        ref={this.Fuel} title="Fuel" required multiple={false}
                        table_name="fuel" table={db.tables.fuel}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.fuel, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.fuel, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.fuel.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxDateTime ref={this.Datetime} required defaultValue={this.props.isEdit ? undefined : new Date()} title="Datetime" style={{ width: NSBox.width.double }} />
                    <NSRow style={{ gap: 8 }}>
                        <NSBoxInteger ref={this.Quantity} required title="Quantity" style={{ width: NSBox.width.one }} />
                        <NSBoxEnum<RefuelingUnit>
                            ref={this.Unit} title="Unit" required multiple={false}
                            getEnumObject={() => RefuelingUnit}
                            style={{ width: NSBox.width.one }}
                        />
                    </NSRow>
                    <NSBoxBoolean ref={this.IsFullTank} required checked={false} title="Full Tank" style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}